import ContentPageTemplate from '@/components/ContentPageTemplate';
import VideoTestimonials from '@/components/VideoTestimonials';
import { marketingPages } from '@/data/marketingPages';

export default function ReviewsPage() {
  return <ContentPageTemplate page={marketingPages.reviews} after={<VideoTestimonials />} />;
}
